import { useState } from "react";

// Import images (organized clearly)
import aiImg from "./images/Ai_img.png";
import aiImg1 from "./images/Ai_img2.png";
import aiImg2 from "./images/Ai_img3.png";

import dsImg from "./images/ds_img.png";
import dsImg1 from "./images/ds_img1.png";
import dsImg2 from "./images/ds_img2.png";

import pythonImg from "./images/python_img.png";
import pythonImg1 from "./images/python_img1.png";

import autoImg from "./images/auto_img.png";
import autoImg1 from "./images/auto_img1.png";

import csImg from "./images/cc_img.png";
import csImg1 from "./images/cc_img1.png";

const SkillCourses = () => {
  const categories = [
    {
      name: "Artificial Intelligence (AI)",
      courses: [
        {
          title: "AI Engineer Bootcamp 2025",
          author: "TechPro Academy",
          price: "₹2,999",
          rating: 4.6,
          ratingsCount: "10,500",
          badge: "Bestseller",
          img: aiImg,
        },
        {
          title: "AI for Business Professionals",
          author: "Innovate AI",
          price: "₹1,899",
          rating: 4.7,
          ratingsCount: "8,300",
          badge: "Premium",
          img: aiImg1,
        },
        {
          title: "Master Prompt Engineering with ChatGPT",
          author: "FutureSkills",
          price: "₹2,499",
          rating: 4.8,
          ratingsCount: "6,870",
          badge: "Bestseller",
          img: aiImg2,
        },
      ],
    },
    {
      name: "Data Science",
      courses: [
        {
          title: "Data Science Mastery 2025",
          author: "CodeLab",
          price: "₹2,499",
          rating: 4.7,
          ratingsCount: "9,000",
          badge: "Bestseller",
          img: dsImg,
        },
        {
          title: "Statistics & ML for Beginners",
          author: "LearnSmart",
          price: "₹1,799",
          rating: 4.5,
          ratingsCount: "4,400",
          badge: "Premium",
          img: dsImg1,
        },
        {
          title: "Python for Data Analysis",
          author: "ProLearn",
          price: "₹1,999",
          rating: 4.6,
          ratingsCount: "7,600",
          badge: "Bestseller",
          img: dsImg2,
        },
      ],
    },
    {
      name: "Python",
      courses: [
        {
          title: "Complete Python Bootcamp 2025",
          author: "PyMasters",
          price: "₹1,499",
          rating: 4.8,
          ratingsCount: "25,000",
          badge: "Bestseller",
          img: pythonImg,
        },
        {
          title: "Python Automation with Selenium",
          author: "AutoTech",
          price: "₹2,099",
          rating: 4.7,
          ratingsCount: "6,700",
          badge: "Premium",
          img: pythonImg1,
        },
      ],
    },
    {
      name: "Automation",
      courses: [
        {
          title: "Robotic Process Automation (RPA)",
          author: "TechSkill Academy",
          price: "₹2,499",
          rating: 4.6,
          ratingsCount: "5,900",
          badge: "Bestseller",
          img: autoImg,
        },
        {
          title: "Test Automation with Cypress",
          author: "QA World",
          price: "₹1,999",
          rating: 4.5,
          ratingsCount: "3,400",
          badge: "Premium",
          img: autoImg1,
        },
      ],
    },
    {
      name: "Cloud Computing",
      courses: [
        {
          title: "AWS Certified Solutions Architect 2025",
          author: "CloudMasters",
          price: "₹3,499",
          rating: 4.8,
          ratingsCount: "12,000",
          badge: "Bestseller",
          img: csImg,
        },
        {
          title: "Azure Fundamentals for Beginners",
          author: "CloudStart",
          price: "₹2,099",
          rating: 4.6,
          ratingsCount: "4,200",
          badge: "Premium",
          img: csImg1,
        },
      ],
    },
  ];

  const [activeCategory, setActiveCategory] = useState(categories[0]);

  return (
    <section className="py-16 bg-gray-900 text-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-bold mb-2">
          Skills to transform your career and life
        </h2>
        <p className="text-gray-400 mb-8">
          From critical skills to technical topics, Smarty supports your professional growth.
        </p>

        {/* Category Tabs */}
        <div className="flex flex-wrap gap-6 mb-10 border-b border-gray-700 pb-4">
          {categories.map((cat) => (
            <button
              key={cat.name}
              onClick={() => setActiveCategory(cat)}
              className={`pb-2 border-b-2 transition-colors ${
                activeCategory.name === cat.name
                  ? "border-purple-500 text-purple-400"
                  : "border-transparent hover:text-purple-300"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>

        {/* Courses Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {activeCategory.courses.map((course, index) => (
            <div
              key={index}
              className="bg-gray-800 rounded-xl shadow-lg hover:shadow-purple-800/40 overflow-hidden transition-transform hover:-translate-y-1"
            >
              <img
                src={course.img}
                alt={course.title}
                className="h-48 w-full object-cover"
              />
              <div className="p-5">
                <h3 className="text-lg font-semibold mb-1">{course.title}</h3>
                <p className="text-sm text-gray-400 mb-2">{course.author}</p>
                <div className="flex items-center gap-2 text-sm mb-2">
                  <span
                    className={`px-2 py-0.5 rounded text-xs font-semibold ${
                      course.badge === "Bestseller"
                        ? "bg-green-500/20 text-green-400"
                        : "bg-purple-500/20 text-purple-400"
                    }`}
                  >
                    {course.badge}
                  </span>
                  <span>⭐ {course.rating}</span>
                  <span className="text-gray-500">
                    ({course.ratingsCount} ratings)
                  </span>
                </div>
                <p className="font-bold text-lg">{course.price}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10">
          <a
            href="#"
            className="text-purple-400 hover:underline font-medium text-sm"
          >
            Show all {activeCategory.name} courses →
          </a>
        </div>
      </div>
    </section>
  );
};

export default SkillCourses;
